import React, { useEffect, useState } from 'react';
import axios from "axios";

import { Header } from "../../components/Header";
import { Button } from '../../components/Button';
import { API_URL } from "../../constants";

import './admin.styles.scss';

interface Student {
  name: string;
  role?: string;
  code?: string;
  timestamp?: number;
  _id?: number;
}

export const AdminBoard: React.FC = () => {
  const [students, setStudents] = useState<Student[]>([]);

  const [pageData, setPageData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios.get(`${API_URL}/admin-dashboard`, {
      withCredentials: true, // if using cookies for auth
    })
      .then(response => {
        setPageData(response.data);

        const fetchData = async () => {
          try {
            const response = await axios.get(`${API_URL}/users`);
            setStudents(response.data);
            console.log(response.data)
          } catch (error) {
            console.log("Error while fetching data", error);
          }
        };
        fetchData();
      })
      .catch(err => {
        setError(err.response?.data?.message || err.message);
      });
  }, []);

  if (error) return <div>Error: {error}</div>;
  if (!pageData) return <div>Loading...</div>;

  // useEffect ( () => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await axios.get("http://localhost:8000/users");
  //       setStudents(response.data);
  //       console.log(response.data)
  //     } catch (error) {
  //       console.log("Error while fetching data", error);
  //     }
  //   };
  //   fetchData();
  // }, [])

  return (
    <>
      <Header goBack={true} logOut={true} />
      <main className="LandingContainer">
        <>
          <h1>Super Admin Dashboard</h1>
          <Button>Add teacher</Button>
          <h2>Users</h2>
            <table>
              <thead>
                <tr>
                  <th></th>
                  <th>Name</th>
                  <th>Role</th>
                  <th>DB ID</th>
                </tr>
              </thead>
              <tbody>
                {students?.map((student, key) =>
                  <tr>
                    <td>{key+1}</td>
                    <td>{student.name}</td>
                    <td>{student.role}</td>
                    <td>{student._id}</td>
                  </tr>
                )}
              </tbody>
            </table>
            {students?.map(student => console.log(student))}
            <Button>Add student</Button>
            <Button>Add topic</Button>
          </>
      </main>
    </>
  );
};
